(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("elformdesign", [], factory);
	else if(typeof exports === 'object')
		exports["elformdesign"] = factory();
	else
		root["elformdesign"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 16);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var assembly = function assembly(type, name, col, key) {
  _classCallCheck(this, assembly);

  this.id = type + new Date().getTime();
  this.type = type;
  this.name = name;
  this.col = col;
  this.key = key;
};

/* harmony default export */ __webpack_exports__["a"] = (assembly);

/***/ }),
/* 1 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(20)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 3 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formitem_vue__ = __webpack_require__(11);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92133dce_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formitem_vue__ = __webpack_require__(46);
function injectStyle (ssrContext) {
  __webpack_require__(44)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formitem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92133dce_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formitem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assembly__ = __webpack_require__(0);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var MInput = function (_assembly) {
  _inherits(MInput, _assembly);

  function MInput() {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Input';
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '文本框';
    var col = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 24;
    var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'Input' + new Date().getTime();

    _classCallCheck(this, MInput);

    var _this = _possibleConstructorReturn(this, (MInput.__proto__ || Object.getPrototypeOf(MInput)).call(this, type, name, col, key));

    _this.showFrom = ['name', 'col', 'key', 'minlength', 'maxlength', 'showwordlimit', 'placeholder', 'clearable', 'showpassword', 'disabled', 'prefixicon', 'suffixicon', 'prepend', 'append'];
    _this.minlength = 0;
    _this.maxlength = 100;
    _this.showwordlimit = true;
    _this.placeholder = '请输入' + _this.name;
    _this.clearable = true;
    _this.showpassword = false;
    _this.disabled = false;
    _this.prefixicon = 'el-icon-edit';
    _this.suffixicon = '';
    _this.prepend = '';
    _this.append = '';
    // 校验
    _this.rules = [{ required: false, message: '请输入' + _this.name, trigger: 'change' }];

    return _this;
  }

  return MInput;
}(__WEBPACK_IMPORTED_MODULE_0__assembly__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (MInput);

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dow__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assembly__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__forms__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__attributeform__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ShowForms__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'formdesign',
  components: {
    Assembly: __WEBPACK_IMPORTED_MODULE_1__assembly__["a" /* default */], Forms: __WEBPACK_IMPORTED_MODULE_2__forms__["a" /* default */], AttrFrom: __WEBPACK_IMPORTED_MODULE_3__attributeform__["a" /* default */], ShowFrom: __WEBPACK_IMPORTED_MODULE_4__ShowForms__["a" /* default */]
  },
  props: {
    formdata: {
      type: Object
    },
    fields: {
      type: Array,
      default: function _default() {
        return [{ label: '姓名', value: 'name' }, { label: '年龄', value: 'age' }];
      }
    }
  },
  data: function data() {
    return {
      // 是否正在拖动左侧的组件 1 没有动  2 已经拖动没有进入中间的界面  3拖动进入中间的页面 4 进入设计页面中的组件
      drag1: '1',
      // 是否正在拖动中间的组件 1 没有动  2 已经拖动没有进度其他组件  3 进入其他组件
      drag2: '1',
      // 左边 被操作的组件
      com: {},
      // 中间正在被拖动的组件的 如果拖动到垃圾桶 将会删除它
      delcom: {},
      // 表单列表
      data: [],
      // 表单设置
      formsetting: {
        labelPosition: 'left',
        labelwidth: 80,
        formsize: 'small'
      },
      // 中间被点击的组件
      formcom: {
        showFrom: [],
        rules: []
      },
      dialogVisible: false
    };
  },
  created: function created() {
    // 当传入props 值时 设置进入当前的data
    if (this.formdata && this.formdata.formsetting && this.formdata.forms) {
      this.formsetting = this.formdata.formsetting;
      this.data = this.formdata.forms;
    }
  },
  mounted: function mounted() {},

  methods: {
    // 左边的全部重置 左边的结束拖动时调用
    reset: function reset() {
      this.drag1 = '1';
      this.drag2 = '1';
      // 重置中间的横线
      this.$refs.forms.chonzhihxindex();
    },

    // 预览的 对话框
    setdialogVisible: function setdialogVisible() {
      this.dialogVisible = true;
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },

    // 设置拖动状态
    setdrag: function setdrag(data) {
      this[data.type] = data.value;
    },

    // 设置操作的组件
    setcom: function setcom(data) {
      this.com = data;
    },
    setdelcom: function setdelcom(data) {
      this.delcom = data;
    },
    setformcom: function setformcom(data) {
      this.formcom = data;
    },

    // 清空
    qingkong: function qingkong() {
      this.data = [];
      this.formcom = {
        showFrom: [],
        rules: []
      };
    },

    // 删除
    deletecom: function deletecom() {
      var _this = this;

      // 如果删除的是 被选中的 则把 选中的也清空
      if (this.delcom.id === this.formcom.id) {
        this.formcom = {
          showFrom: [],
          rules: []
        };
      }
      this.data = this.data.filter(function (item) {
        return item.id !== _this.delcom.id;
      });
    },

    // 增加一个组件
    addcom: function addcom() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;

      if (index == -1) {
        this.data.push(this.com);
      } else {
        this.data.splice(index, 0, this.com);
      }
    },

    // 交换位置
    jiaohuan: function jiaohuan(start, end) {
      var arr = this.data;
      // JSON.parse(JSON.stringify(this.data))
      var aa = arr[start];
      arr[start] = arr[end];
      arr[end] = aa;
      this.data = arr;
    },
    save: function save() {
      this.$emit('save', { formsetting: this.formsetting, forms: this.data });
    },

    // 下载
    download: function download(filename, text) {
      var element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
      element.setAttribute('download', filename);
      element.style.display = 'none';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    },
    downloadvue: function downloadvue() {
      var filename = 'hello.vue';
      var text = Object(__WEBPACK_IMPORTED_MODULE_0__dow__["a" /* default */])(this.formsetting, this.data);
      console.log(text);
      this.download(filename, text);
    }
  }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assembly_input__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assembly_textarea__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assembly_inputNumber__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assembly_select__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assembly_tableform__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assembly_switch__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assembly_slider__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assembly_timeselect__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assembly_timepicker__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assembly_datePicker__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assembly_radio__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assembly_checkbox__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assembly_divider__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assembly_p__ = __webpack_require__(36);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    drag2: {
      type: String,
      default: function _default() {
        return '1';
      }
    }
  },
  components: {},
  data: function data() {
    return {
      lj: false,
      data: [{ type: 'divider', name: '分割线' }, { type: 'p', name: '文字' }, { type: 'input', name: '文本框' }, { type: 'Textarea', name: '文本域' }, { type: 'InputNumber', name: '计数器' }, { type: 'Select', name: '下拉框' }, { type: 'Switch', name: '开关' }, { type: 'Slider', name: '滑块' }, { type: 'Timeselect', name: '固定时间' }, { type: 'Timepicker', name: '任意时间' }, { type: 'DatePicker', name: '日期' }, { type: 'Radio', name: '单选' }, { type: 'Checkbox', name: '多选' }, { type: 'TableForm', name: '表格' }]
    };
  },
  created: function created() {},

  computed: {
    zzcindex: function zzcindex() {
      return this.drag2 === '1' ? -10 : 10;
    }
  },
  methods: {
    click: function click(item) {
      this.$emit('setcom', this.getobj(item));
      this.$emit('addcom');
    },
    getobj: function getobj(data) {
      var obj = {};
      if (data.type === 'input') {
        obj = new __WEBPACK_IMPORTED_MODULE_0__assembly_input__["a" /* default */]();
      } else if (data.type === 'Textarea') {
        obj = new __WEBPACK_IMPORTED_MODULE_1__assembly_textarea__["a" /* default */]();
      } else if (data.type === 'InputNumber') {
        obj = new __WEBPACK_IMPORTED_MODULE_2__assembly_inputNumber__["a" /* default */]();
      } else if (data.type === 'Select') {
        obj = new __WEBPACK_IMPORTED_MODULE_3__assembly_select__["a" /* default */]();
      } else if (data.type === 'Switch') {
        obj = new __WEBPACK_IMPORTED_MODULE_5__assembly_switch__["a" /* default */]();
      } else if (data.type === 'Slider') {
        obj = new __WEBPACK_IMPORTED_MODULE_6__assembly_slider__["a" /* default */]();
      } else if (data.type === 'Timeselect') {
        obj = new __WEBPACK_IMPORTED_MODULE_7__assembly_timeselect__["a" /* default */]();
      } else if (data.type === 'Timepicker') {
        obj = new __WEBPACK_IMPORTED_MODULE_8__assembly_timepicker__["a" /* default */]();
      } else if (data.type === 'DatePicker') {
        obj = new __WEBPACK_IMPORTED_MODULE_9__assembly_datePicker__["a" /* default */]();
      } else if (data.type === 'Radio') {
        obj = new __WEBPACK_IMPORTED_MODULE_10__assembly_radio__["a" /* default */]();
      } else if (data.type === 'Checkbox') {
        obj = new __WEBPACK_IMPORTED_MODULE_11__assembly_checkbox__["a" /* default */]();
      } else if (data.type === 'TableForm') {
        obj = new __WEBPACK_IMPORTED_MODULE_4__assembly_tableform__["a" /* default */]();
      } else if (data.type === 'divider') {
        obj = new __WEBPACK_IMPORTED_MODULE_12__assembly_divider__["a" /* default */]();
      } else if (data.type === 'p') {
        obj = new __WEBPACK_IMPORTED_MODULE_13__assembly_p__["a" /* default */]();
      }
      return obj;
    },
    dragstart: function dragstart(data) {
      this.$emit("setdrag", { type: 'drag1', value: '2' });
      var obj = this.getobj(data);
      this.$emit('setcom', obj);
    },
    dragend: function dragend() {
      this.$emit('reset');
    },
    drop: function drop() {
      this.lj = false;
      this.$emit('deletecom');
    },
    dragover: function dragover() {
      this.lj = true;
    },
    dragleave: function dragleave() {
      this.lj = false;
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assembly__ = __webpack_require__(0);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var MTextarea = function (_assembly) {
  _inherits(MTextarea, _assembly);

  function MTextarea() {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Textarea';
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '文本域';
    var col = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 24;
    var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'Textarea' + new Date().getTime();
    var rows = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;

    _classCallCheck(this, MTextarea);

    var _this = _possibleConstructorReturn(this, (MTextarea.__proto__ || Object.getPrototypeOf(MTextarea)).call(this, type, name, col, key));

    _this.showFrom = ['name', 'col', 'key', 'rows', 'minlength', 'maxlength', 'showwordlimit', 'placeholder', 'clearable', 'disabled'];
    _this.rows = rows;
    _this.minlength = 0;
    _this.maxlength = 100;
    _this.showwordlimit = true;
    _this.placeholder = '请输入' + _this.name;
    _this.clearable = true;
    _this.disabled = false;
    // 校验
    _this.rules = [{ required: false, message: '请输入' + _this.name, trigger: 'change' }];
    return _this;
  }

  return MTextarea;
}(__WEBPACK_IMPORTED_MODULE_0__assembly__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (MTextarea);

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tableForm__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formitem__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "forms",
  components: {
    tableForm: __WEBPACK_IMPORTED_MODULE_0__tableForm__["a" /* default */], FormItem: __WEBPACK_IMPORTED_MODULE_1__formitem__["a" /* default */]
  },
  // 是否正在拖动组件
  props: {
    drag1: {
      type: String,
      default: function _default() {
        return "1";
      }
    },
    drag2: {
      type: String,
      default: function _default() {
        return "1";
      }
    },
    fromData: {
      type: Array,
      default: function _default() {
        return [{ name: "111" }];
      }
    },
    formsetting: {
      type: Object,
      default: function _default() {
        return {
          labelPosition: 'left',
          labelwidth: 80,
          formsize: 'small'
        };
      }
    },
    // 左侧正在被拖动的组件
    com: {
      type: Object
    },
    height: {
      type: Number,
      default: function _default() {
        return 600;
      }
    }
  },
  data: function data() {
    return {
      startindex: -1,
      endindex: -1,
      // 表单的值
      from: {},
      // 拖动到表格  1 没有  2 有
      drag3: '1',
      // -3 为没有 -2 为大的div的下面 -1 为大的div的上面  其他为 小组件
      hxindex: -3,
      // 被点击选中的id值
      actid: '0'
    };
  },
  created: function created() {
    this.initfrom();
    console.log(111);
  },

  methods: {
    // Checkbox 需要提前初始化
    initfrom: function initfrom() {
      var obj = {};
      this.fromData.map(function (item) {
        if (item.type === 'Checkbox') {
          obj[item.key] = [];
        }
      });
      this.from = obj;
    },

    // 拖动到表格
    setdrag3: function setdrag3(data) {
      this.drag3 = data;
    },

    // 重置数据
    centerreset: function centerreset() {
      this.startindex = -1;
      this.endindex = -1;
      this.drag3 = '1';
      this.hxindex = -3;
      this.actid = 0;
    },
    chonzhihxindex: function chonzhihxindex() {
      this.hxindex = -3;
    },

    // 大div 中滑动时
    dragover: function dragover() {
      // 中间没有拖动时
      if (this.drag2 === "1") {
        this.$emit("setdrag", { type: 'drag1', value: '3' });
        // 一个都没有时 在上面 否则在下面
        if (this.fromData.length === 0) {
          this.hxindex = -1;
        } else {
          this.hxindex = -2;
        }
      }
    },

    // 离开大div时 
    dragleave: function dragleave() {
      // 当进入到小div中时  或者在操作小div 时 不处理
      if (this.drag1 == "4" || this.drag2 != "1") {
        return;
      }
      this.$emit("setdrag", { type: 'drag1', value: '2' });
      this.hxindex = -3;
    },

    // 在div 中放下时
    dropfun: function dropfun() {
      // 不是中间的拖动时 者添加到中间的表单中
      if (this.drag2 === "1") {
        this.$emit("addcom");
        this.hxindex = -3;
      }
      this.drag3 = '1';
    },

    // 在组件中的
    dragstart: function dragstart(index, data) {
      this.$emit("setdrag", { type: 'drag2', value: '2' });
      this.$emit('setdelcom', data);
      this.startindex = index;
      console.log("开始拖动 小div", index);
    },
    dragend: function dragend() {
      // 重置数据
      console.log('中间的end ------------');
      this.startindex = -1;
      this.endindex = -1;
      this.drag3 = '1';
      this.$emit("reset");
    },

    // 在组件中滑动
    dragover2: function dragover2(index) {
      // 处理 从左侧拖动到中间组件的逻辑
      if (this.drag2 === "1" && this.drag1 !== "1") {
        this.$emit("setdrag", { type: 'drag1', value: '4' });
        this.hxindex = index;
        // todo 增加横线
      }
      // 中间拖动进入到 中间的其他组件
      if (this.drag1 === "1" && this.drag2 !== "1") {
        if (index !== this.startindex) {
          this.endindex = index;
          this.$emit("setdrag", { type: 'drag2', value: '3' });
        } else {
          this.endindex = -1;
        }
      }
    },
    dragleave2: function dragleave2(index) {
      this.endindex = -1;
    },
    dropfun2: function dropfun2(index) {
      // 中间的进行拖动交换
      if (this.drag1 === "1") {
        this.$emit("setdrag", { type: 'drag2', value: '1' });
        if (this.startindex !== this.endindex && this.startindex != -1 && this.endindex != -1) {
          this.$emit("jiaohuan", this.startindex, this.endindex);
        }
      }
      // 从左侧进入到小div中放下  并且没有进入到表格中时 进行对应位置的添加
      if (this.drag1 === "4" && this.drag3 != '2') {
        this.$emit("addcom", index);
        this.hxindex = -3;
      }
      this.drag3 = '1';
    },

    // 选中中间的组件
    clickitem: function clickitem(data) {
      console.log('data..');
      console.log(data);
      this.actid = data.id;
      this.$emit('setformcom', data);
    },
    sub: function sub() {
      alert(JSON.stringify(this.from));
    },

    // 预览
    yulan: function yulan() {
      this.$emit('setdialogVisible', true);
    },

    // 保存
    save: function save() {
      this.$emit('save');
    }
  },
  computed: {
    // 中间的大的div
    styleCard: function styleCard() {
      // drag1 是否正在拖动左侧的组件 1 没有动 2 已经拖动没有进入中间的界面  3拖动进入中间的页面 4 进入设计页面中的组件
      // drag2 是否正在拖动中间的组件 1 没有动  2 已经拖动没有进度其他组件  3 进入其他组件
      var sty = { background: "rgb(0,0,0,0)" };
      if (this.drag1 == "2") {
        // sty.background = 'rgb(0,0,0,0.1)'
      } else if (this.drag1 == "3") {
        // sty.background = 'rgb(0,0,0,0.5)'
        // sty["z-index"] = 10;
      }
      return sty;
    },
    styleitem: function styleitem() {
      var sty = { "z-index": 100 };
      // if (this.drag2 == '2') {
      // }
      return sty;
    }
  },
  watch: {
    // fromData 变化时初始化表单
    fromData: function fromData() {
      this.initfrom();
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formitem__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FormItem: __WEBPACK_IMPORTED_MODULE_0__formitem__["a" /* default */]
  },
  props: {
    // 被选中的 id值
    drag1: {
      type: String,
      default: function _default() {
        return '1';
      }
    },
    drag2: {
      type: String,
      default: function _default() {
        return '1';
      }
    },
    // 1 没有拖动到 表格中  2 已经拖动到表格中
    drag3: {
      type: String,
      default: function _default() {
        return '1';
      }
    },
    // 用来判断是否是中间内容的拖动 为 -1 时 就不是  大于 0 的 都是 (此时不进行处理)
    startindex: {
      type: Number,
      default: function _default() {
        return -1;
      }
    },
    field: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    // 表格的对象
    data: {
      type: Object,
      default: function _default() {
        return {
          column: []
        };
      }
    },
    // 左侧被拉动的组件 如果在table 中放开 则添加到table 中
    com: {
      type: Object
    }
  },
  computed: {
    column: function column() {
      return this.data.column;
    },
    contdivstyle: function contdivstyle() {
      var obj = {};
      // obj.background = this.drag3 === '1' ? 'rgba(0,0,0,0.1)' : 'rgba(0,0,0,0.2)'
      // 左侧或者 中间拖动的时候 要 大等于 10
      obj['z-index'] = this.drag1 !== '1' ? 100 : -1;

      return obj;
    }
  },
  data: function data() {
    return {
      tablekey: 'tablekey' + new Date().getTime(),
      dynamicValidateForm: {
        domains: []
      }
    };
  },

  methods: {
    dragenter: function dragenter() {
      console.log('进入目标>>>');
      // this.$emit('setmub', true)
    },
    dragover: function dragover() {
      // 当在表格上滑动的时候
      this.$emit('setdrag3', '2');
      // console.log('在表格上>>>')
    },
    dragleave: function dragleave() {
      this.$emit('setdrag3', '1');
      console.log('移出目标>>>');
      // this.$emit('setmub', false)
    },
    drop: function drop() {
      // todo 进行添加操作 并且 hxindex 置为 -3
      if (this.com.type != 'TableForm') {
        this.data.addcolumn(this.com);
      } else if (this.startindex === '-1') {
        // 中间的拖动到表格中 不处理
      } else {
          // this.$message.error('不能在表格中添加表格')
        }
      this.$emit('chonzhihxindex');
      console.log(this.data);
      console.log('方>>>');
    },
    submitForm: function submitForm(formName) {
      var _this = this;

      console.log(this.dynamicValidateForm);
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          console.log(_this.dynamicValidateForm);
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    removeDomain: function removeDomain(item) {
      var index = this.dynamicValidateForm.domains.indexOf(item);
      if (index !== -1) {
        this.dynamicValidateForm.domains.splice(index, 1);
      }
    },
    set: function set(data) {
      this.$emit('clickitem', data);
    },
    del: function del(data) {
      this.data.deletecolumn(data.id);
    }
  },
  watch: {
    data: {
      handler: function handler() {
        this.tablekey = 'tablekey' + new Date().getTime();
      },

      deep: true
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "formitem",
  components: {},
  props: {
    // 表单对象
    form: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 表单内的组件对象
    item: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    forms: function forms() {
      return this.form;
    }
  },
  data: function data() {
    return {};
  },

  methods: {},
  watch: {}
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assembly_input__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assembly_textarea__ = __webpack_require__(8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    // 中间是否拖动
    drag2: {
      type: String,
      default: function _default() {
        return '1';
      }
    },
    // 组件对象
    form: {
      type: Object,
      default: function _default() {
        return {
          // 展示字段
          showFrom: [],
          // 校验
          rules: []
        };
      }
    },
    formsetting: {
      type: Object
    },
    // 传递过来的可选字段
    fields: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  components: {},
  data: function data() {
    return {
      activeName: '1',
      formclass: '',
      // 垃圾桶
      lj: false
    };
  },
  created: function created() {},

  computed: {
    fieldsdata: function fieldsdata() {
      var ret = [];
      // 是数组      
      if (Array.isArray(this.fields)) {
        ret = this.fields;
      }
      return ret;
    },
    zzcindex: function zzcindex() {
      return this.drag2 === '1' ? -10 : 10;
    }
  },
  methods: {
    drop: function drop() {
      this.lj = false;
      this.$emit('deletecom');
    },
    dragover: function dragover() {
      this.lj = true;
      console.log('滑动时');
    },
    dragleave: function dragleave() {
      this.lj = false;
      console.log('出去了');
    },

    // 删除选项
    handleDelete: function handleDelete(index) {
      this.form.deleteOption(index);
    },
    addoption: function addoption() {
      this.form.addoption();
    }
  },
  watch: {
    form: function form() {
      var thiz = this;
      this.formclass = 'animated bounceInRight';
      var timer = setTimeout(function () {
        thiz.formclass = '';
        window.clearTimeout(timer);
      }, 1000);
      console.log('bianhua');
    }
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShowForms_vue__ = __webpack_require__(14);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_417d041c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShowForms_vue__ = __webpack_require__(59);
function injectStyle (ssrContext) {
  __webpack_require__(53)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShowForms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_417d041c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShowForms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formitem__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__showTableForm__ = __webpack_require__(55);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 初始化form 
// 1 下拉框多选时为 数组
// 2 开关进入之后 默认 false
// 3 滑块范围选择时为数组
// 4 多选 需要初始化为 数组


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "showforms",
  components: {
    Formitem: __WEBPACK_IMPORTED_MODULE_0__formitem__["a" /* default */], showTableForm: __WEBPACK_IMPORTED_MODULE_1__showTableForm__["a" /* default */]
  },
  props: {
    data: {
      type: Object,
      default: function _default() {
        return {
          formsetting: {
            labelPosition: 'left',
            labelwidth: 80,
            formsize: 'small'
          },
          forms: []
        };
      }
    },
    defaultData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      formkey: 'formkey',
      form: {}
    };
  },
  created: function created() {
    this.initform();
  },

  methods: {
    initform: function initform() {
      var obj = this.defaultData;
      this.data.forms.map(function (item) {
        if (item.type === 'Checkbox') {
          obj[item.key] = [];
        }
      });
      this.form = obj;
    },

    // 设置table 的数据
    settabledata: function settabledata(data) {
      this.form[data.field] = data.data;
    },
    submitForm: function submitForm(formName) {
      var _this = this;

      var pd = true;
      // 调用表格的提交按钮
      for (var k in this.$refs) {
        if (k != 'showform') {
          var pdt = this.$refs[k][0].submitForm('dynamicValidateForm');
          if (!pdt) {
            pd = false;
          }
          console.log(pd, '...');
        }
      }
      // 当前表单的校验
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (pd) {
            _this.$emit('save', _this.form);
          }
        } else {
          console.log('error submit!!');
          _this.$emit('save', false);
          return false;
        }
      });
    }
  },
  computed: {},
  watch: {
    data: {
      handler: function handler() {
        this.formkey = 'formkey' + new Date().getTime();
      },

      deep: true
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formitem__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FromItem: __WEBPACK_IMPORTED_MODULE_0__formitem__["a" /* default */]
  },
  props: {
    // 表单对象
    form: {
      type: Object,
      default: function _default() {
        return _defineProperty({}, data.key, []);
      }
    },
    // 表格的对象
    data: {
      type: Object,
      default: function _default() {
        return {
          column: []
        };
      }
    }
  },
  computed: {
    column: function column() {
      return this.data.column;
    }
  },
  data: function data() {
    return {
      obj: {},
      dynamicValidateForm: {
        domains: []
      }
    };
  },
  created: function created() {
    this.init();
  },

  methods: {
    // 初始化默认值
    init: function init() {
      var obj = {};
      this.column.map(function (item) {
        if (item.type === 'Checkbox') {
          obj[item.key] = [];
        }
      });
      this.obj = obj;
      this.dynamicValidateForm.domains.push(obj);
    },
    submitForm: function submitForm(formName) {
      var _this = this;

      console.log(this.dynamicValidateForm);
      var ret = true;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this.$emit('settabledata', { field: _this.data.key, data: _this.dynamicValidateForm.domains });
        } else {
          console.log("error submit!!");
          ret = false;
          // return false;
        }
      });
      return ret;
    },
    removeDomain: function removeDomain(item) {
      var index = this.dynamicValidateForm.domains.indexOf(item);
      if (index !== -1) {
        this.dynamicValidateForm.domains.splice(index, 1);
      }
    }
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formDesign_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ShowForms_vue__ = __webpack_require__(13);




var test = {};
test.install = function (Vue, options) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__formDesign_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__formDesign_vue__["a" /* default */]);
  Vue.component(__WEBPACK_IMPORTED_MODULE_1__ShowForms_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__ShowForms_vue__["a" /* default */]);
};
/* harmony default export */ __webpack_exports__["default"] = (test);

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formDesign_vue__ = __webpack_require__(6);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ddff1d48_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formDesign_vue__ = __webpack_require__(60);
function injectStyle (ssrContext) {
  __webpack_require__(18)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formDesign_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ddff1d48_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formDesign_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(19);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("65b31a5a", content, true, {});

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 20 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = gettext;


function gettext(formsetting, data) {
  var text = "\n<template>\n  <div>\n    <showforms :data=\"data\" @save='save' :defaultData='defaultData'/>\n  </div>\n</template>\n  \n<script>\n  export default {\n    data() {\n      return {\n        data: {\n          formsetting: " + JSON.stringify(formsetting) + ",\n          forms: " + JSON.stringify(data) + ",\n        },\n        defaultData: {\n          name:1,\n          age:2\n        }\n      };\n    },\n    methods: {\n      save(data) {\n        // \u901A\u8FC7\u6821\u9A8C\u65F6 \u8FD4\u56DE \u7528\u6237\u63D0\u4EA4\u7684\u8868\u5355\u6570\u636E  \u672A\u901A\u8FC7\u65F6 \u8FD4\u56DEfalse\n        if (data) {\n          console.log(data)\n        }\n      }\n    }\n  };\n</script>\n  \n<style scoped>\n  .cont {\n    width: 800px;\n    margin: 20px auto;\n  }\n</style>\n";
  return text;
}

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_assembly_vue__ = __webpack_require__(7);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05e1ce8d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_assembly_vue__ = __webpack_require__(37);
function injectStyle (ssrContext) {
  __webpack_require__(23)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-05e1ce8d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_assembly_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05e1ce8d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_assembly_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(24);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("a350fa52", content, true, {});

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".assemblycont[data-v-05e1ce8d]{position:relative;min-height:700px}.assemblycontzzc[data-v-05e1ce8d]{position:absolute;top:0;right:0;left:0;bottom:0;background:#fff}.assemblycont_item[data-v-05e1ce8d]{background:#f1f2fd;display:flex;justify-content:center;align-items:center;height:40px;margin-bottom:10px;box-sizing:border-box;transition:.3s;cursor:pointer;cursor:move;font-size:14px}.assemblycont_item[data-v-05e1ce8d]:hover{border:1px dashed #579ff8;color:#579ff8;transition:.3s}.imgclass[data-v-05e1ce8d]{width:200px;height:200px}.lajitongdiv[data-v-05e1ce8d]{position:absolute;top:0;right:0;left:0;bottom:0;display:flex;justify-content:center;align-items:center}", ""]);

// exports


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assembly__ = __webpack_require__(0);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var MInputNumber = function (_assembly) {
  _inherits(MInputNumber, _assembly);

  function MInputNumber() {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'InputNumber';
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '计数器';
    var col = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 24;
    var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'InputNumber' + new Date().getTime();

    _classCallCheck(this, MInputNumber);

    var _this = _possibleConstructorReturn(this, (MInputNumber.__proto__ || Object.getPrototypeOf(MInputNumber)).call(this, type, name, col, key));

    _this.showFrom = ['name', 'col', 'key', 'min', 'max', 'step', 'stepstrictly', 'precision', 'disabled', 'controlsposition', 'placeholder'];
    _this.min = 0;
    _this.max = 10000;
    _this.step = 1;
    _this.stepstrictly = false;
    _this.precision = 1;
    _this.disabled = false;
    _this.controlsposition = 'right';
    _this.placeholder = '请输入' + _this.name;
    // 校验
    _this.rules = [{ required: false, message: '请输入' + _this.name, trigger: 'change' }];
    return _this;
  }

  return MInputNumber;
}(__WEBPACK_IMPORTED_MODULE_0__assembly__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (MInputNumber);

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assembly__ = __webpack_require__(0);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var MSelect = function (_assembly) {
  _inherits(MSelect, _assembly);

  function MSelect() {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Select';
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '下拉框';
    var col = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 24;
    var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'Select' + new Date().getTime();

    _classCallCheck(this, MSelect);

    var _this = _possibleConstructorReturn(this, (MSelect.__proto__ || Object.getPrototypeOf(MSelect)).call(this, type, name, col, key));

    _this.showFrom = ['name', 'col', 'key', 'multiple', 'collapsetags', 'placeholder', 'clearable', 'disabled', 'filterable', 'allowcreate', 'datatype', 'option', 'url'];
    _this.multiple = false;
    _this.collapsetags = false;
    _this.disabled = false;
    _this.filterable = false;
    _this.allowcreate = false;
    _this.placeholder = '请输入' + _this.name;
    _this.clearable = true;
    // 数据类型 option 和 url
    _this.datatype = 'option';
    // 请求接口
    _this.url = '';
    // 下拉框的选项
    _this.option = [{
      value: 'Beijing',
      label: '北京'
    }, {
      value: 'Shanghai',
      label: '上海'
    }, {
      value: 'Tianjin',
      label: '天津'
    }, {
      value: 'ChongQing',
      label: '重庆'
    }];
    // 校验
    _this.rules = [{ required: false, message: '请输入' + _this.name, trigger: 'change' }];

    return _this;
  }

  _createClass(MSelect, [{
    key: 'deleteOption',
    value: function deleteOption(index) {
      this.option.splice(index, 1);
    }
  }, {
    key: 'addoption',
    value: function addoption() {
      this.option.push({ label: '新的选择', value: 'newValue' });
    }
  }]);

  return MSelect;
}(__WEBPACK_IMPORTED_MODULE_0__assembly__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (MSelect);

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assembly__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(5);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var MInputNumber = function (_assembly) {
  _inherits(MInputNumber, _assembly);

  function MInputNumber() {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'TableForm';
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '表格';
    var col = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 24;
    var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'TableForm' + new Date().getTime();

    _classCallCheck(this, MInputNumber);

    var _this = _possibleConstructorReturn(this, (MInputNumber.__proto__ || Object.getPrototypeOf(MInputNumber)).call(this, type, name, col, key));

    _this.showFrom = ['name', 'col', 'key', 'border', 'stripe'];

    _this.border = true;
    _this.stripe = false;
    // 表格的校验在内部的组件中
    _this.rules = [];
    // 表单表头
    _this.column = [new __WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */]()];
    // { key: 'name', type: 'input',label: '名称', rules:[{ required: true, message: '名称不能为空', trigger: 'change'}] },
    // { key: 'name2', type: 'input',label: '名称2', rules:[{ required: true, message: '名称不能为空', trigger: 'change'}] },
    return _this;
  }

  _createClass(MInputNumber, [{
    key: 'addcolumn',
    value: function addcolumn(data) {
      this.column.push(data);
    }
  }, {
    key: 'deletecolumn',
    value: function deletecolumn(id) {
      this.column = this.column.filter(function (item) {
        return item.id != id;
      });
    }
  }]);

  return MInputNumber;
}(__WEBPACK_IMPORTED_MODULE_0__assembly__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (MInputNumber);

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assembly__ = __webpack_require__(0);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var MSwitch = function (_assembly) {
  _inherits(MSwitch, _assembly);

  function MSwitch() {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Switch';
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '开关';
    var col = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 24;
    var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'Switch' + new Date().getTime();

    _classCallCheck(this, MSwitch);

    var _this = _possibleConstructorReturn(this, (MSwitch.__proto__ || Object.getPrototypeOf(MSwitch)).call(this, type, name, col, key));

    _this.showFrom = ['name', 'col', 'key', 'disabled', 'activetext', 'inactivetext', 'activecolor', 'inactivecolor'];
    _this.disabled = false;
    _this.activetext = '开';
    _this.inactivetext = '关';
    _this.activecolor = '#409EFF';
    _this.inactivecolor = '#C0CCDA';

    // 校验
    _this.rules = [{ required: false, message: '请输入' + _this.name, trigger: 'change' }];
    return _this;
  }

  return MSwitch;
}(__WEBPACK_IMPORTED_MODULE_0__assembly__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (MSwitch);

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assembly__ = __webpack_require__(0);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var MSlider = function (_assembly) {
  _inherits(MSlider, _assembly);

  function MSlider() {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Slider';
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '滑块';
    var col = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 24;
    var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'Slider' + new Date().getTime();

    _classCallCheck(this, MSlider);

    var _this = _possibleConstructorReturn(this, (MSlider.__proto__ || Object.getPrototypeOf(MSlider)).call(this, type, name, col, key));

    _this.showFrom = ['name', 'col', 'key', 'min', 'max', 'disabled', 'step', 'showstops', 'showinput', 'range'];
    _this.min = 0;
    _this.max = 100;
    _this.disabled = false;
    _this.step = 1;
    _this.showstops = false;
    _this.showinput = false;
    // 多选
    _this.range = false;

    // 校验
    _this.rules = [{ required: false, message: '请输入' + _this.name, trigger: 'change' }];
    return _this;
  }

  return MSlider;
}(__WEBPACK_IMPORTED_MODULE_0__assembly__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (MSlider);

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assembly__ = __webpack_require__(0);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var MTimepicker = function (_assembly) {
  _inherits(MTimepicker, _assembly);

  function MTimepicker() {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Timeselect';
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '固定时间';
    var col = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 24;
    var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'Timeselect' + new Date().getTime();

    _classCallCheck(this, MTimepicker);

    var _this = _possibleConstructorReturn(this, (MTimepicker.__proto__ || Object.getPrototypeOf(MTimepicker)).call(this, type, name, col, key));

    _this.showFrom = ['name', 'col', 'key', 'disabled', 'placeholder', 'pickeroptions', 'clearable', 'prefixicon'];
    _this.disabled = false;
    _this.placeholder = '请输入' + _this.name;
    _this.clearable = false;
    _this.prefixicon = 'el-icon-time';

    _this.pickeroptions = {
      start: '09:00',
      end: '18:00',
      step: '00:15'

      // 校验
    };_this.rules = [{ required: false, message: '请输入' + _this.name, trigger: 'change' }];
    return _this;
  }

  return MTimepicker;
}(__WEBPACK_IMPORTED_MODULE_0__assembly__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (MTimepicker);

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assembly__ = __webpack_require__(0);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var MTimepicker = function (_assembly) {
  _inherits(MTimepicker, _assembly);

  function MTimepicker() {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Timepicker';
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '任意时间';
    var col = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 24;
    var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'Timepicker' + new Date().getTime();

    _classCallCheck(this, MTimepicker);

    var _this = _possibleConstructorReturn(this, (MTimepicker.__proto__ || Object.getPrototypeOf(MTimepicker)).call(this, type, name, col, key));

    _this.showFrom = ['name', 'col', 'key', 'disabled', 'placeholder', 'clearable', 'prefixicon', 'isrange', 'startplaceholder', 'endplaceholder', 'rangeseparator'];
    _this.disabled = false;
    _this.placeholder = '请输入' + _this.name;
    _this.clearable = false;
    _this.prefixicon = 'el-icon-time';

    _this.isrange = false;
    _this.startplaceholder = '开始时间';
    _this.endplaceholder = '结束时间';
    _this.rangeseparator = '至';

    // 校验
    _this.rules = [{ required: false, message: '请输入' + _this.name, trigger: 'change' }];
    return _this;
  }

  return MTimepicker;
}(__WEBPACK_IMPORTED_MODULE_0__assembly__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (MTimepicker);

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assembly__ = __webpack_require__(0);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var MDatePicker = function (_assembly) {
  _inherits(MDatePicker, _assembly);

  function MDatePicker() {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'DatePicker';
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '日期';
    var col = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 24;
    var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'DatePicker' + new Date().getTime();

    _classCallCheck(this, MDatePicker);

    var _this = _possibleConstructorReturn(this, (MDatePicker.__proto__ || Object.getPrototypeOf(MDatePicker)).call(this, type, name, col, key));

    _this.showFrom = ['name', 'col', 'key', 'disabled', 'placeholder', 'clearable', 'prefixicon', 'datetype', 'startplaceholder', 'endplaceholder', 'rangeseparator'];
    _this.placeholder = '请输入' + _this.name;
    _this.clearable = false;
    _this.disabled = false;
    _this.prefixicon = 'el-icon-time';
    _this.datetype = 'date';
    _this.startplaceholder = '开始时间';
    _this.endplaceholder = '结束时间';
    _this.rangeseparator = '至';

    // 校验
    _this.rules = [{ required: false, message: '请输入' + _this.name, trigger: 'change' }];
    return _this;
  }

  return MDatePicker;
}(__WEBPACK_IMPORTED_MODULE_0__assembly__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (MDatePicker);

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assembly__ = __webpack_require__(0);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var MRadio = function (_assembly) {
  _inherits(MRadio, _assembly);

  function MRadio() {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Radio';
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '单选';
    var col = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 24;
    var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'Radio' + new Date().getTime();

    _classCallCheck(this, MRadio);

    var _this = _possibleConstructorReturn(this, (MRadio.__proto__ || Object.getPrototypeOf(MRadio)).call(this, type, name, col, key));

    _this.showFrom = ['name', 'col', 'key', 'disabled', 'radiotype', 'datatype', 'option', 'url'];
    // button
    _this.radiotype = 'yuan';
    _this.disabled = false;

    // 数据类型 option 和 url
    _this.datatype = 'option';
    // 请求接口
    _this.url = '';
    // 下拉框的选项
    _this.option = [{
      value: 'Beijing',
      label: '北京'
    }, {
      value: 'Shanghai',
      label: '上海'
    }, {
      value: 'Tianjin',
      label: '天津'
    }, {
      value: 'ChongQing',
      label: '重庆'
    }];
    // 校验
    _this.rules = [{ required: false, message: '请输入' + _this.name, trigger: 'change' }];
    return _this;
  }

  _createClass(MRadio, [{
    key: 'deleteOption',
    value: function deleteOption(index) {
      this.option.splice(index, 1);
    }
  }, {
    key: 'addoption',
    value: function addoption() {
      this.option.push({ label: '新的选择', value: 'newValue' });
    }
  }]);

  return MRadio;
}(__WEBPACK_IMPORTED_MODULE_0__assembly__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (MRadio);

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assembly__ = __webpack_require__(0);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var MCheckbox = function (_assembly) {
  _inherits(MCheckbox, _assembly);

  function MCheckbox() {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Checkbox';
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '多选';
    var col = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 24;
    var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'Checkbox' + new Date().getTime();

    _classCallCheck(this, MCheckbox);

    var _this = _possibleConstructorReturn(this, (MCheckbox.__proto__ || Object.getPrototypeOf(MCheckbox)).call(this, type, name, col, key));

    _this.showFrom = ['name', 'col', 'key', 'disabled', 'checkboxtype', 'datatype', 'option', 'url', 'min', 'max'];
    // button
    _this.checkboxtype = 'fang';
    _this.disabled = false;
    _this.min = 0;
    _this.max = 2;

    // 数据类型 option 和 url
    _this.datatype = 'option';
    // 请求接口
    _this.url = '';
    // 下拉框的选项
    _this.option = [{
      value: 'Beijing',
      label: '北京'
    }, {
      value: 'Shanghai',
      label: '上海'
    }, {
      value: 'Tianjin',
      label: '天津'
    }, {
      value: 'ChongQing',
      label: '重庆'
    }];
    // 校验
    _this.rules = [{ required: false, message: '请输入' + _this.name, trigger: 'change' }];
    return _this;
  }

  _createClass(MCheckbox, [{
    key: 'deleteOption',
    value: function deleteOption(index) {
      this.option.splice(index, 1);
    }
  }, {
    key: 'addoption',
    value: function addoption() {
      this.option.push({ label: '新的选择', value: 'newValue' });
    }
  }]);

  return MCheckbox;
}(__WEBPACK_IMPORTED_MODULE_0__assembly__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (MCheckbox);

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assembly__ = __webpack_require__(0);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var MDivider = function (_assembly) {
  _inherits(MDivider, _assembly);

  function MDivider() {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Divider';
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var col = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 24;
    var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'Divider' + new Date().getTime();

    _classCallCheck(this, MDivider);

    var _this = _possibleConstructorReturn(this, (MDivider.__proto__ || Object.getPrototypeOf(MDivider)).call(this, type, name, col, key));

    _this.showFrom = ['col', 'text', 'contentposition'];
    _this.text = '';
    _this.contentposition = 'center';
    _this.rules = [];
    return _this;
  }

  return MDivider;
}(__WEBPACK_IMPORTED_MODULE_0__assembly__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (MDivider);

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assembly__ = __webpack_require__(0);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var MP = function (_assembly) {
  _inherits(MP, _assembly);

  function MP() {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'p';
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var col = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 24;
    var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'p' + new Date().getTime();

    _classCallCheck(this, MP);

    var _this = _possibleConstructorReturn(this, (MP.__proto__ || Object.getPrototypeOf(MP)).call(this, type, name, col, key));

    _this.showFrom = ['col', 'text', 'contentposition', 'fontsize', 'textcolor'];
    _this.text = '某某表单';
    _this.contentposition = 'center';
    _this.fontsize = 18;
    _this.textcolor = '#333';
    _this.rules = [];
    return _this;
  }

  return MP;
}(__WEBPACK_IMPORTED_MODULE_0__assembly__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (MP);

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{staticClass:"assemblycont"},[_c('div',{staticClass:"assemblycontzzc",style:({'z-index':_vm.zzcindex})}),_vm._v(" "),_c('el-row',{attrs:{"gutter":10}},_vm._l((_vm.data),function(item,index){return _c('el-col',{key:index,attrs:{"span":12}},[_c('div',{staticClass:"assemblycont_item",attrs:{"draggable":""},on:{"click":function($event){return _vm.click(item)},"dragstart":function($event){return _vm.dragstart(item)},"dragend":_vm.dragend}},[_vm._v("\n          "+_vm._s(item.name)+"\n        ")])])}),1),_vm._v(" "),_c('div',{staticClass:"lajitongdiv",style:({'z-index':_vm.zzcindex+1}),on:{"dragover":[_vm.dragover,function($event){$event.preventDefault();}],"dragleave":_vm.dragleave,"drop":_vm.drop}},[(!_vm.lj)?_c('svg',{attrs:{"t":"1584024586503","viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","p-id":"2016","width":"200","height":"200"}},[_c('path',{attrs:{"d":"M652.8 834.56c15.36 0 25.6-10.24 25.6-25.6v-307.2c0-15.36-10.24-25.6-25.6-25.6s-25.6 10.24-25.6 25.6v307.2c0 12.8 10.24 25.6 25.6 25.6z m-128 0c15.36 0 25.6-10.24 25.6-25.6v-307.2c0-15.36-10.24-25.6-25.6-25.6s-25.6 10.24-25.6 25.6v307.2c0 12.8 10.24 25.6 25.6 25.6z m281.6-614.4h-153.6v-51.2c0-28.16-23.04-51.2-51.2-51.2h-153.6c-28.16 0-51.2 23.04-51.2 51.2v51.2h-153.6c-28.16 0-51.2 23.04-51.2 51.2v51.2c0 28.16 23.04 51.2 51.2 51.2v460.8c0 56.32 46.08 102.4 102.4 102.4h358.4c56.32 0 102.4-46.08 102.4-102.4v-460.8c28.16 0 51.2-23.04 51.2-51.2v-51.2c0-28.16-23.04-51.2-51.2-51.2z m-358.4-25.6c0-15.36 10.24-25.6 25.6-25.6h102.4c15.36 0 25.6 10.24 25.6 25.6v25.6h-153.6v-25.6z m307.2 640c0 28.16-23.04 51.2-51.2 51.2h-358.4c-28.16 0-51.2-23.04-51.2-51.2v-460.8h460.8v460.8z m25.6-512h-512c-15.36 0-25.6-10.24-25.6-25.6s10.24-25.6 25.6-25.6h512c15.36 0 25.6 10.24 25.6 25.6 0 12.8-10.24 25.6-25.6 25.6z m-384 512c15.36 0 25.6-10.24 25.6-25.6v-307.2c0-15.36-10.24-25.6-25.6-25.6s-25.6 10.24-25.6 25.6v307.2c0 12.8 10.24 25.6 25.6 25.6z","p-id":"2017","fill":"#1296db"}})]):_vm._e(),_vm._v(" "),(_vm.lj)?_c('svg',{attrs:{"t":"1584029734035","viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","p-id":"6049","width":"200","height":"200"}},[_c('path',{attrs:{"d":"M652.8 834.56c15.36 0 25.6-10.24 25.6-25.6v-307.2c0-15.36-10.24-25.6-25.6-25.6s-25.6 10.24-25.6 25.6v307.2c0 12.8 10.24 25.6 25.6 25.6z m-128 0c15.36 0 25.6-10.24 25.6-25.6v-307.2c0-15.36-10.24-25.6-25.6-25.6s-25.6 10.24-25.6 25.6v307.2c0 12.8 10.24 25.6 25.6 25.6z m281.6-614.4h-153.6v-51.2c0-28.16-23.04-51.2-51.2-51.2h-153.6c-28.16 0-51.2 23.04-51.2 51.2v51.2h-153.6c-28.16 0-51.2 23.04-51.2 51.2v51.2c0 28.16 23.04 51.2 51.2 51.2v460.8c0 56.32 46.08 102.4 102.4 102.4h358.4c56.32 0 102.4-46.08 102.4-102.4v-460.8c28.16 0 51.2-23.04 51.2-51.2v-51.2c0-28.16-23.04-51.2-51.2-51.2z m-358.4-25.6c0-15.36 10.24-25.6 25.6-25.6h102.4c15.36 0 25.6 10.24 25.6 25.6v25.6h-153.6v-25.6z m307.2 640c0 28.16-23.04 51.2-51.2 51.2h-358.4c-28.16 0-51.2-23.04-51.2-51.2v-460.8h460.8v460.8z m25.6-512h-512c-15.36 0-25.6-10.24-25.6-25.6s10.24-25.6 25.6-25.6h512c15.36 0 25.6 10.24 25.6 25.6 0 12.8-10.24 25.6-25.6 25.6z m-384 512c15.36 0 25.6-10.24 25.6-25.6v-307.2c0-15.36-10.24-25.6-25.6-25.6s-25.6 10.24-25.6 25.6v307.2c0 12.8 10.24 25.6 25.6 25.6z","p-id":"6050","fill":"#d4237a"}})]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forms_vue__ = __webpack_require__(9);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ed21b3d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_forms_vue__ = __webpack_require__(48);
function injectStyle (ssrContext) {
  __webpack_require__(39)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6ed21b3d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ed21b3d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_forms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(40);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("f18c0e46", content, true, {});

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".elcard[data-v-6ed21b3d]{position:relative;min-height:600px}.elcardzz[data-v-6ed21b3d]{position:absolute;top:58px;left:0;right:0;bottom:0}.formscont[data-v-6ed21b3d]{min-height:600px}.formitem[data-v-6ed21b3d]{border-radius:3px}.formitem2[data-v-6ed21b3d],.formitem[data-v-6ed21b3d]{position:relative;padding:3px;overflow:hidden;box-sizing:border-box}.formitem2[data-v-6ed21b3d]{border-radius:3px;border:1px dashed #3a88ed;cursor:move}.formitem2[data-v-6ed21b3d]:hover{border:1px dashed red;transition:.5s}.formitemzz[data-v-6ed21b3d]{position:absolute;top:0;left:0;right:0;bottom:0}.hxdiv[data-v-6ed21b3d]{width:100%;height:2px;background:red;border-radius:2px}.icons1[data-v-6ed21b3d]{position:absolute;top:0;right:0}", ""]);

// exports


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tableForm_vue__ = __webpack_require__(10);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f1ff199_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tableForm_vue__ = __webpack_require__(47);
function injectStyle (ssrContext) {
  __webpack_require__(42)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f1ff199"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tableForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f1ff199_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tableForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(43);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("c5ccf01e", content, true, {});

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".cont[data-v-3f1ff199]{position:relative;width:100%;height:117px}.contdiv[data-v-3f1ff199]{position:absolute;top:0;right:0;left:0;bottom:0;z-index:100;transition:all .5s;border-radius:3px;overflow:hidden}.icons[data-v-3f1ff199]{text-align:right;z-index:10000;cursor:pointer}.icons[data-v-3f1ff199]:hover{color:red}", ""]);

// exports


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(45);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("82828d66", content, true, {});

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.item.type==="Input")?_c('el-input',{staticStyle:{"width":"100%"},attrs:{"show-word-limit":_vm.item.showwordlimit,"minlength":_vm.item.minlength,"maxlength":_vm.item.maxlength,"placeholder":_vm.item.placeholder,"clearable":_vm.item.clearable,"show-password":_vm.item.showpassword,"disabled":_vm.item.disabled,"prefix-icon":_vm.item.prefixicon,"suffix-icon":_vm.item.suffixicon},model:{value:(_vm.forms[_vm.item.key]),callback:function ($$v) {_vm.$set(_vm.forms, _vm.item.key, $$v)},expression:"forms[item.key]"}},[(_vm.item.prepend!=="")?_c('template',{slot:"prepend"},[_vm._v(_vm._s(_vm.item.prepend))]):_vm._e(),_vm._v(" "),(_vm.item.append!=="")?_c('template',{slot:"append"},[_vm._v(_vm._s(_vm.item.append))]):_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.item.type==="Textarea")?_c('el-input',{staticStyle:{"width":"100%"},attrs:{"type":"textarea","rows":_vm.item.rows,"show-word-limit":_vm.item.showwordlimit,"minlength":_vm.item.minlength,"maxlength":_vm.item.maxlength,"placeholder":_vm.item.placeholder,"clearable":_vm.item.clearable,"disabled":_vm.item.disabled},model:{value:(_vm.forms[_vm.item.key]),callback:function ($$v) {_vm.$set(_vm.forms, _vm.item.key, $$v)},expression:"forms[item.key]"}}):_vm._e(),_vm._v(" "),(_vm.item.type==="InputNumber")?_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"min":_vm.item.min,"max":_vm.item.max,"step":_vm.item.step,"step-strictly":_vm.item.stepstrictly,"precision":_vm.item.precision,"disabled":_vm.item.disabled,"controls-position":_vm.item.controlsposition,"placeholder":_vm.item.placeholder},model:{value:(_vm.forms[_vm.item.key]),callback:function ($$v) {_vm.$set(_vm.forms, _vm.item.key, $$v)},expression:"forms[item.key]"}}):_vm._e(),_vm._v(" "),(_vm.item.type==="Select")?_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.item.placeholder,"multiple":_vm.item.multiple,"collapse-tags":"","disabled":_vm.item.disabled,"clearable":_vm.item.clearable,"filterable":_vm.item.filterable,"allow-create":_vm.item.allowcreate},model:{value:(_vm.forms[_vm.item.key]),callback:function ($$v) {_vm.$set(_vm.forms, _vm.item.key, $$v)},expression:"forms[item.key]"}},_vm._l((_vm.item.option),function(item2){return _c('el-option',{key:item2.value,attrs:{"label":item2.label,"value":item2.value}},[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(item2.label))])])}),1):_vm._e(),_vm._v(" "),(_vm.item.type==="Switch")?_c('el-switch',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.item.disabled,"active-text":_vm.item.activetext,"inactive-text":_vm.item.inactivetext,"active-color":_vm.item.activecolor,"inactive-color":_vm.item.inactivecolor},model:{value:(_vm.forms[_vm.item.key]),callback:function ($$v) {_vm.$set(_vm.forms, _vm.item.key, $$v)},expression:"forms[item.key]"}}):_vm._e(),_vm._v(" "),(_vm.item.type==="Slider")?_c('el-slider',{staticStyle:{"width":"100%"},attrs:{"min":_vm.item.min,"max":_vm.item.max,"disabled":_vm.item.disabled,"step":_vm.item.step,"show-stops":_vm.item.showstops,"show-input":_vm.item.showinput,"range":_vm.item.range},model:{value:(_vm.forms[_vm.item.key]),callback:function ($$v) {_vm.$set(_vm.forms, _vm.item.key, $$v)},expression:"forms[item.key]"}}):_vm._e(),_vm._v(" "),(_vm.item.type==="Timeselect")?_c('el-time-select',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.item.disabled,"clearable":_vm.item.clearable,"picker-options":_vm.item.pickeroptions,"placeholder":_vm.item.placeholder,"prefix-icon":_vm.item.prefixicon,"value-format":"HH:mm:ss"},model:{value:(_vm.forms[_vm.item.key]),callback:function ($$v) {_vm.$set(_vm.forms, _vm.item.key, $$v)},expression:"forms[item.key]"}}):_vm._e(),_vm._v(" "),(_vm.item.type==="Timepicker")?_c('el-time-picker',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.item.disabled,"clearable":_vm.item.clearable,"placeholder":_vm.item.placeholder,"prefix-icon":_vm.item.prefixicon,"is-range":_vm.item.isrange,"start-placeholder":_vm.item.startplaceholder,"end-placeholder":_vm.item.endplaceholder,"range-separator":_vm.item.rangeseparator,"value-format":"HH:mm:ss"},model:{value:(_vm.forms[_vm.item.key]),callback:function ($$v) {_vm.$set(_vm.forms, _vm.item.key, $$v)},expression:"forms[item.key]"}}):_vm._e(),_vm._v(" "),(_vm.item.type==="DatePicker" && ( _vm.item.datetype=="date" || _vm.item.datetype=="dates" || _vm.item.datetype=="daterange"))?_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":_vm.item.datetype,"placeholder":_vm.item.placeholder,"clearable":_vm.item.clearable,"disabled":_vm.item.disabled,"prefix-icon":_vm.item.prefixicon,"value-format":"yyyy-MM-dd","start-placeholder":_vm.item.startplaceholder,"end-placeholder":_vm.item.endplaceholder,"range-separator":_vm.item.rangeseparator},model:{value:(_vm.forms[_vm.item.key]),callback:function ($$v) {_vm.$set(_vm.forms, _vm.item.key, $$v)},expression:"forms[item.key]"}}):_vm._e(),_vm._v(" "),(_vm.item.type==="DatePicker" && _vm.item.datetype=="week")?_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"week","format":"yyyy 第 WW 周","value-format":"yyyy-MM-dd","placeholder":_vm.item.placeholder,"clearable":_vm.item.clearable,"disabled":_vm.item.disabled,"prefix-icon":_vm.item.prefixicon,"start-placeholder":_vm.item.startplaceholder,"end-placeholder":_vm.item.endplaceholder,"range-separator":_vm.item.rangeseparator},model:{value:(_vm.forms[_vm.item.key]),callback:function ($$v) {_vm.$set(_vm.forms, _vm.item.key, $$v)},expression:"forms[item.key]"}}):_vm._e(),_vm._v(" "),(_vm.item.type==="DatePicker" && ( _vm.item.datetype=="month"|| _vm.item.datetype=="monthrange" )  )?_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":_vm.item.datetype,"placeholder":_vm.item.placeholder,"clearable":_vm.item.clearable,"disabled":_vm.item.disabled,"prefix-icon":_vm.item.prefixicon,"value-format":"yyyy-MM","start-placeholder":_vm.item.startplaceholder,"end-placeholder":_vm.item.endplaceholder,"range-separator":_vm.item.rangeseparator},model:{value:(_vm.forms[_vm.item.key]),callback:function ($$v) {_vm.$set(_vm.forms, _vm.item.key, $$v)},expression:"forms[item.key]"}}):_vm._e(),_vm._v(" "),(_vm.item.type==="DatePicker" && _vm.item.datetype=="year")?_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"year","placeholder":_vm.item.placeholder,"clearable":_vm.item.clearable,"disabled":_vm.item.disabled,"prefix-icon":_vm.item.prefixicon,"value-format":"yyyy","start-placeholder":_vm.item.startplaceholder,"end-placeholder":_vm.item.endplaceholder,"range-separator":_vm.item.rangeseparator},model:{value:(_vm.forms[_vm.item.key]),callback:function ($$v) {_vm.$set(_vm.forms, _vm.item.key, $$v)},expression:"forms[item.key]"}}):_vm._e(),_vm._v(" "),(_vm.item.type==="DatePicker" && (_vm.item.datetype=="datetime" || _vm.item.datetype=="datetimerange") )?_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":_vm.item.datetype,"placeholder":_vm.item.placeholder,"clearable":_vm.item.clearable,"disabled":_vm.item.disabled,"prefix-icon":_vm.item.prefixicon,"value-format":"yyyy-MM-dd HH:mm:ss","start-placeholder":_vm.item.startplaceholder,"end-placeholder":_vm.item.endplaceholder,"range-separator":_vm.item.rangeseparator},model:{value:(_vm.forms[_vm.item.key]),callback:function ($$v) {_vm.$set(_vm.forms, _vm.item.key, $$v)},expression:"forms[item.key]"}}):_vm._e(),_vm._v(" "),(_vm.item.type==="Radio")?_c('el-radio-group',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.item.disabled},model:{value:(_vm.forms[_vm.item.key]),callback:function ($$v) {_vm.$set(_vm.forms, _vm.item.key, $$v)},expression:"forms[item.key]"}},[(_vm.item.radiotype==="yuan")?_c('div',_vm._l((_vm.item.option),function(item2,index2){return _c('el-radio',{key:index2,attrs:{"label":item2.value}},[_vm._v(_vm._s(item2.label))])}),1):_vm._e(),_vm._v(" "),(_vm.item.radiotype==="button")?_c('div',_vm._l((_vm.item.option),function(item2,index2){return _c('el-radio-button',{key:index2,attrs:{"label":item2.value}},[_vm._v(_vm._s(item2.label))])}),1):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.item.type==="Checkbox")?_c('el-checkbox-group',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.item.disabled,"border":_vm.item.border,"min":_vm.item.min,"max":_vm.item.max},model:{value:(_vm.forms[_vm.item.key]),callback:function ($$v) {_vm.$set(_vm.forms, _vm.item.key, $$v)},expression:"forms[item.key]"}},[(_vm.item.checkboxtype=== "fang")?_c('div',_vm._l((_vm.item.option),function(item2,index2){return _c('el-checkbox',{key:index2,attrs:{"label":item2.value}},[_vm._v(_vm._s(item2.label))])}),1):_vm._e(),_vm._v(" "),(_vm.item.checkboxtype=== "button")?_c('div',_vm._l((_vm.item.option),function(item2,index2){return _c('el-checkbox-button',{key:index2,attrs:{"label":item2.value}},[_vm._v(_vm._s(item2.label))])}),1):_vm._e()]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cont"},[_c('div',{staticClass:"contdiv",style:(_vm.contdivstyle),on:{"dragenter":_vm.dragenter,"dragleave":_vm.dragleave,"dragover":[_vm.dragover,function($event){$event.preventDefault();}],"drop":_vm.drop}}),_vm._v(" "),_c('el-form',{ref:"dynamicValidateForm",staticClass:"demo-dynamic",attrs:{"model":_vm.dynamicValidateForm,"label-width":"0","size":"mini"}},[_c('el-table',{key:_vm.tablekey,staticClass:"tb-edit",staticStyle:{"width":"100%"},attrs:{"empty-text":"拖动左侧的组件到表格中","border":_vm.data.border,"data":_vm.dynamicValidateForm.domains,"highlight-current-row":""}},[_c('el-table-column',{attrs:{"align":"center","type":"index","width":"50"}}),_vm._v(" "),_vm._l((_vm.data.column),function(item,index){return _c('el-table-column',{key:'column'+index,attrs:{"align":"center","label":item.name + (item.rules.length > 0 ? '(必填)':'(可选)')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_c('el-form-item',{key:scope.$index,attrs:{"rules":item.rules,"prop":'domains.' + scope.$index + '.' + item.key}},[_c('FormItem',{attrs:{"item":"item"}})],1)],1)]}}],null,true)},[_c('template',{slot:"header"},[_c('div',{staticClass:"headeritem"},[(item.rules.length > 0 && item.rules[0].required)?_c('span',{staticStyle:{"color":"#F56C6C"}},[_vm._v("*")]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('i',{staticClass:"el-icon-setting icons",on:{"click":function($event){$event.stopPropagation();return _vm.set(item)}}}),_vm._v(" "),_c('i',{staticClass:"el-icon-delete icons",on:{"click":function($event){$event.stopPropagation();return _vm.del(item)}}})])])],2)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","label":"操作","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"mini","type":"danger"},on:{"click":function($event){return _vm.removeDomain(scope.row)}}},[_vm._v("删除")])]}}])})],2),_vm._v(" "),_c('el-form-item')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{staticClass:"elcard"},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("表单设计")]),_vm._v(" "),_c('el-button',{staticStyle:{"float":"right","padding":"3px 0","margin-left":"5px"},attrs:{"type":"text"},on:{"click":_vm.save}},[_vm._v("保存")]),_vm._v(" "),_c('el-button',{staticStyle:{"float":"right","padding":"3px 0","margin-left":"5px"},attrs:{"type":"text"},on:{"click":_vm.yulan}},[_vm._v("预览")]),_vm._v(" "),_c('el-button',{staticStyle:{"float":"right","padding":"3px 0","margin-left":"5px"},attrs:{"type":"text"},on:{"click":function (){ return this$1.$emit('downloadvue'); }}},[_vm._v("下载源码")])],1),_vm._v(" "),_c('div',{staticClass:"elcardzz",style:(_vm.styleCard),on:{"dragover":[_vm.dragover,function($event){$event.preventDefault();}],"dragleave":_vm.dragleave,"drop":_vm.dropfun}}),_vm._v(" "),_c('div',{staticClass:"formscont"},[(_vm.hxindex== -1 && _vm.drag3 !== '2')?_c('div',{staticClass:"hxdiv"}):_vm._e(),_vm._v(" "),_c('el-form',{attrs:{"model":_vm.from,"label-position":_vm.formsetting.labelPosition,"label-width":_vm.formsetting.labelwidth+'px',"size":_vm.formsetting.formsize}},[_c('el-row',{attrs:{"gutter":10}},_vm._l((_vm.fromData),function(item,index){return _c('el-col',{key:index,attrs:{"span":item.col}},[_c('div',{staticClass:"formitem",style:({'background': _vm.startindex == index ? 'rgba(255,0,0,0.2)' : _vm.endindex == index ? 'rgba(0,0,255,0.2)' :''})},[_c('div',{staticClass:"formitem2",style:(Object.assign({}, _vm.styleitem,{border: _vm.actid === item.id ? '1px solid red' : ''})),attrs:{"draggable":""},on:{"dragstart":function($event){return _vm.dragstart(index,item)},"dragend":function($event){return _vm.dragend(index)},"dragover":[function($event){return _vm.dragover2(index)},function($event){$event.preventDefault();}],"dragleave":function($event){return _vm.dragleave2(index)},"drop":function($event){return _vm.dropfun2(index)},"click":function($event){return _vm.clickitem(item)}}},[(_vm.hxindex==index && _vm.drag3 !== '2')?_c('div',{staticClass:"hxdiv"}):_vm._e(),_vm._v(" "),(["TableForm","Divider","p"].indexOf(item.type) == -1 )?_c('el-form-item',{attrs:{"label":item.name,"prop":item.key,"rules":item.rules},model:{value:(_vm.from[item.key]),callback:function ($$v) {_vm.$set(_vm.from, item.key, $$v)},expression:"from[item.key]"}},[_c('FormItem',{attrs:{"item":item,"form":_vm.from}})],1):_vm._e(),_vm._v(" "),(item.type === 'Divider')?_c('el-divider',{attrs:{"content-position":item.contentposition}},[_vm._v(_vm._s(item.text))]):_vm._e(),_vm._v(" "),(item.type === 'p')?_c('p',{style:({'text-align': item.contentposition,'font-size':item.fontsize+'px',color:item.textcolor})},[_vm._v(_vm._s(item.text))]):_vm._e(),_vm._v(" "),(item.type==="TableForm")?_c('el-form-item',{attrs:{"label":item.name}},[_c('div',[_c('tableForm',{attrs:{"com":_vm.com,"data":item,"drag1":_vm.drag1,"drag2":_vm.drag2,"drag3":_vm.drag3,"startindex":_vm.startindex},on:{"setdrag3":_vm.setdrag3,"chonzhihxindex":_vm.chonzhihxindex,"clickitem":_vm.clickitem}})],1)]):_vm._e()],1)])])}),1)],1),_vm._v(" "),(_vm.hxindex== -2 && _vm.drag3 !== '2')?_c('div',{staticClass:"hxdiv"}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_attributeform_vue__ = __webpack_require__(12);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b224d38_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_attributeform_vue__ = __webpack_require__(52);
function injectStyle (ssrContext) {
  __webpack_require__(50)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5b224d38"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_attributeform_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b224d38_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_attributeform_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(51);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("7dce8dc0", content, true, {});

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, ".attrcont[data-v-5b224d38]{position:relative;min-height:700px}.attrcontzzc[data-v-5b224d38]{position:absolute;top:0;right:0;left:0;bottom:0;background:#fff}.lajitongdiv[data-v-5b224d38]{position:absolute;top:0;right:0;left:0;bottom:0;display:flex;justify-content:center;align-items:center}", ""]);

// exports


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{staticClass:"attrcont"},[_c('div',{staticClass:"attrcontzzc",style:({'z-index':_vm.zzcindex})}),_vm._v(" "),_c('el-tabs',{class:_vm.formclass,attrs:{"type":"card"},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"字段设置","name":"1"}},[_c('el-form',{attrs:{"model":_vm.form,"label-width":"80px","size":"small"}},[(_vm.form.showFrom.indexOf("key") !== -1 && _vm.fieldsdata.length == 0)?_c('el-form-item',{attrs:{"label":"字段名称"}},[_c('el-input',{model:{value:(_vm.form.key),callback:function ($$v) {_vm.$set(_vm.form, "key", $$v)},expression:"form.key"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("key") !== -1 && _vm.fieldsdata.length > 0)?_c('el-form-item',{attrs:{"label":"字段名称"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"allow-create":"","filterable":""},model:{value:(_vm.form.key),callback:function ($$v) {_vm.$set(_vm.form, "key", $$v)},expression:"form.key"}},_vm._l((_vm.fieldsdata),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.value,"value":item.value}},[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(item.label))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","color":"#8492a6","font-size":"13px"}},[_vm._v(_vm._s(item.value))])])}),1)],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("name") !== -1)?_c('el-form-item',{attrs:{"label":"中文名"}},[_c('el-input',{model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("col") !== -1)?_c('el-form-item',{attrs:{"label":"栅格格数"}},[_c('el-input-number',{attrs:{"min":1,"max":24},model:{value:(_vm.form.col),callback:function ($$v) {_vm.$set(_vm.form, "col", $$v)},expression:"form.col"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("rows") !== -1)?_c('el-form-item',{attrs:{"label":"默认行数"}},[_c('el-input-number',{attrs:{"min":1,"max":10},model:{value:(_vm.form.rows),callback:function ($$v) {_vm.$set(_vm.form, "rows", $$v)},expression:"form.rows"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("minlength") !== -1)?_c('el-form-item',{attrs:{"label":"最小长度"}},[_c('el-input-number',{attrs:{"min":0},model:{value:(_vm.form.minlength),callback:function ($$v) {_vm.$set(_vm.form, "minlength", $$v)},expression:"form.minlength"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("maxlength") !== -1)?_c('el-form-item',{attrs:{"label":"最大长度"}},[_c('el-input-number',{attrs:{"min":0},model:{value:(_vm.form.maxlength),callback:function ($$v) {_vm.$set(_vm.form, "maxlength", $$v)},expression:"form.maxlength"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("showwordlimit") !== -1)?_c('el-form-item',{attrs:{"label":"字数统计"}},[_c('el-switch',{attrs:{"active-color":"#13ce66","inactive-color":"#ff4949"},model:{value:(_vm.form.showwordlimit),callback:function ($$v) {_vm.$set(_vm.form, "showwordlimit", $$v)},expression:"form.showwordlimit"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("placeholder") !== -1)?_c('el-form-item',{attrs:{"label":"占位内容"}},[_c('el-input',{model:{value:(_vm.form.placeholder),callback:function ($$v) {_vm.$set(_vm.form, "placeholder", $$v)},expression:"form.placeholder"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("clearable") !== -1)?_c('el-form-item',{attrs:{"label":"可否清空"}},[_c('el-switch',{attrs:{"active-color":"#13ce66","inactive-color":"#ff4949"},model:{value:(_vm.form.clearable),callback:function ($$v) {_vm.$set(_vm.form, "clearable", $$v)},expression:"form.clearable"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("showpassword") !== -1)?_c('el-form-item',{attrs:{"label":"密码框"}},[_c('el-switch',{attrs:{"active-color":"#13ce66","inactive-color":"#ff4949"},model:{value:(_vm.form.showpassword),callback:function ($$v) {_vm.$set(_vm.form, "showpassword", $$v)},expression:"form.showpassword"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("disabled") !== -1)?_c('el-form-item',{attrs:{"label":"是否禁用"}},[_c('el-switch',{attrs:{"active-color":"#13ce66","inactive-color":"#ff4949"},model:{value:(_vm.form.disabled),callback:function ($$v) {_vm.$set(_vm.form, "disabled", $$v)},expression:"form.disabled"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("prefixicon") !== -1)?_c('el-form-item',{attrs:{"label":"头部图标"}},[_c('el-input',{model:{value:(_vm.form.prefixicon),callback:function ($$v) {_vm.$set(_vm.form, "prefixicon", $$v)},expression:"form.prefixicon"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("suffixicon") !== -1)?_c('el-form-item',{attrs:{"label":"尾部图标"}},[_c('el-input',{model:{value:(_vm.form.suffixicon),callback:function ($$v) {_vm.$set(_vm.form, "suffixicon", $$v)},expression:"form.suffixicon"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("prepend") !== -1)?_c('el-form-item',{attrs:{"label":"前置内容"}},[_c('el-input',{model:{value:(_vm.form.prepend),callback:function ($$v) {_vm.$set(_vm.form, "prepend", $$v)},expression:"form.prepend"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("append") !== -1)?_c('el-form-item',{attrs:{"label":"后置内容"}},[_c('el-input',{model:{value:(_vm.form.append),callback:function ($$v) {_vm.$set(_vm.form, "append", $$v)},expression:"form.append"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("min") !== -1)?_c('el-form-item',{attrs:{"label":"最小值"}},[_c('el-input-number',{model:{value:(_vm.form.min),callback:function ($$v) {_vm.$set(_vm.form, "min", $$v)},expression:"form.min"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("max") !== -1)?_c('el-form-item',{attrs:{"label":"最大值"}},[_c('el-input-number',{model:{value:(_vm.form.max),callback:function ($$v) {_vm.$set(_vm.form, "max", $$v)},expression:"form.max"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("step") !== -1)?_c('el-form-item',{attrs:{"label":"步长"}},[_c('el-input-number',{attrs:{"precision":2},model:{value:(_vm.form.step),callback:function ($$v) {_vm.$set(_vm.form, "step", $$v)},expression:"form.step"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("stepstrictly") !== -1)?_c('el-form-item',{attrs:{"label":"只能是步长的倍数"}},[_c('el-switch',{attrs:{"active-color":"#13ce66","inactive-color":"#ff4949"},model:{value:(_vm.form.stepstrictly),callback:function ($$v) {_vm.$set(_vm.form, "stepstrictly", $$v)},expression:"form.stepstrictly"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("precision") !== -1)?_c('el-form-item',{attrs:{"label":"精确小数点后几位"}},[_c('el-input-number',{attrs:{"min":0,"max":5,"step":1,"stepstrictly":""},model:{value:(_vm.form.precision),callback:function ($$v) {_vm.$set(_vm.form, "precision", $$v)},expression:"form.precision"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("controlsposition") !== -1)?_c('el-form-item',{attrs:{"label":"按钮位置"}},[_c('el-select',{model:{value:(_vm.form.controlsposition),callback:function ($$v) {_vm.$set(_vm.form, "controlsposition", $$v)},expression:"form.controlsposition"}},[_c('el-option',{attrs:{"label":"两边","value":""}}),_vm._v(" "),_c('el-option',{attrs:{"label":"右边","value":"right"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("multiple") !== -1)?_c('el-form-item',{attrs:{"label":"可否多选"}},[_c('el-switch',{attrs:{"active-color":"#13ce66","inactive-color":"#ff4949"},model:{value:(_vm.form.multiple),callback:function ($$v) {_vm.$set(_vm.form, "multiple", $$v)},expression:"form.multiple"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("filterable") !== -1)?_c('el-form-item',{attrs:{"label":"可否搜索"}},[_c('el-switch',{attrs:{"active-color":"#13ce66","inactive-color":"#ff4949"},model:{value:(_vm.form.filterable),callback:function ($$v) {_vm.$set(_vm.form, "filterable", $$v)},expression:"form.filterable"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("allowcreate") !== -1 && _vm.form.filterable)?_c('el-form-item',{attrs:{"label":"可否创建选项"}},[_c('el-switch',{attrs:{"active-color":"#13ce66","inactive-color":"#ff4949"},model:{value:(_vm.form.allowcreate),callback:function ($$v) {_vm.$set(_vm.form, "allowcreate", $$v)},expression:"form.allowcreate"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("collapsetags") !== -1 && _vm.form.multiple)?_c('el-form-item',{attrs:{"label":"选择内容全部展示"}},[_c('el-switch',{attrs:{"active-color":"#13ce66","inactive-color":"#ff4949"},model:{value:(_vm.form.collapsetags),callback:function ($$v) {_vm.$set(_vm.form, "collapsetags", $$v)},expression:"form.collapsetags"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("width") !== -1)?_c('el-form-item',{attrs:{"label":"开关宽度"}},[_c('el-input-number',{attrs:{"min":40,"max":100,"step":1},model:{value:(_vm.form.width),callback:function ($$v) {_vm.$set(_vm.form, "width", $$v)},expression:"form.width"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("activetext") !== -1)?_c('el-form-item',{attrs:{"label":"打开时的文字描述"}},[_c('el-input',{model:{value:(_vm.form.activetext),callback:function ($$v) {_vm.$set(_vm.form, "activetext", $$v)},expression:"form.activetext"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("inactivetext") !== -1)?_c('el-form-item',{attrs:{"label":"关闭时的文字描述"}},[_c('el-input',{model:{value:(_vm.form.inactivetext),callback:function ($$v) {_vm.$set(_vm.form, "inactivetext", $$v)},expression:"form.inactivetext"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("activecolor") !== -1)?_c('el-form-item',{attrs:{"label":"打开时背景色"}},[_c('el-color-picker',{attrs:{"show-alpha":""},model:{value:(_vm.form.activecolor),callback:function ($$v) {_vm.$set(_vm.form, "activecolor", $$v)},expression:"form.activecolor"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("inactivecolor") !== -1)?_c('el-form-item',{attrs:{"label":"关闭时背景色"}},[_c('el-color-picker',{attrs:{"show-alpha":""},model:{value:(_vm.form.inactivecolor),callback:function ($$v) {_vm.$set(_vm.form, "inactivecolor", $$v)},expression:"form.inactivecolor"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("showstops") !== -1)?_c('el-form-item',{attrs:{"label":"显示间断"}},[_c('el-switch',{attrs:{"active-color":"#13ce66","inactive-color":"#ff4949"},model:{value:(_vm.form.showstops),callback:function ($$v) {_vm.$set(_vm.form, "showstops", $$v)},expression:"form.showstops"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("showinput") !== -1)?_c('el-form-item',{attrs:{"label":"输入框"}},[_c('el-switch',{attrs:{"active-color":"#13ce66","inactive-color":"#ff4949"},model:{value:(_vm.form.showinput),callback:function ($$v) {_vm.$set(_vm.form, "showinput", $$v)},expression:"form.showinput"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("range") !== -1)?_c('el-form-item',{attrs:{"label":"范围选择"}},[_c('el-switch',{attrs:{"active-color":"#13ce66","inactive-color":"#ff4949"},model:{value:(_vm.form.range),callback:function ($$v) {_vm.$set(_vm.form, "range", $$v)},expression:"form.range"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("pickeroptions") !== -1)?_c('el-form-item',{attrs:{"label":"开始时间"}},[_c('el-time-picker',{attrs:{"placeholder":"开始时间","value-format":"HH:mm","format":"HH:mm"},model:{value:(_vm.form.pickeroptions.start),callback:function ($$v) {_vm.$set(_vm.form.pickeroptions, "start", $$v)},expression:"form.pickeroptions.start"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("pickeroptions") !== -1)?_c('el-form-item',{attrs:{"label":"结束时间"}},[_c('el-time-picker',{attrs:{"placeholder":"结束时间","value-format":"HH:mm","format":"HH:mm"},model:{value:(_vm.form.pickeroptions.end),callback:function ($$v) {_vm.$set(_vm.form.pickeroptions, "end", $$v)},expression:"form.pickeroptions.end"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("pickeroptions") !== -1)?_c('el-form-item',{attrs:{"label":"步长"}},[_c('el-time-picker',{attrs:{"picker-options":{
              selectableRange: '00:01:00 - 06:00:00'
            },"placeholder":"步长","value-format":"HH:mm","format":"HH:mm"},model:{value:(_vm.form.pickeroptions.step),callback:function ($$v) {_vm.$set(_vm.form.pickeroptions, "step", $$v)},expression:"form.pickeroptions.step"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("isrange") !== -1)?_c('el-form-item',{attrs:{"label":"范围选择"}},[_c('el-switch',{attrs:{"active-color":"#13ce66","inactive-color":"#ff4949"},model:{value:(_vm.form.isrange),callback:function ($$v) {_vm.$set(_vm.form, "isrange", $$v)},expression:"form.isrange"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("startplaceholder") !== -1 && _vm.form.isrange)?_c('el-form-item',{attrs:{"label":"开始位置占位符"}},[_c('el-input',{model:{value:(_vm.form.startplaceholder),callback:function ($$v) {_vm.$set(_vm.form, "startplaceholder", $$v)},expression:"form.startplaceholder"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("endplaceholder") !== -1 && _vm.form.isrange)?_c('el-form-item',{attrs:{"label":"结束位置占位符"}},[_c('el-input',{model:{value:(_vm.form.endplaceholder),callback:function ($$v) {_vm.$set(_vm.form, "endplaceholder", $$v)},expression:"form.endplaceholder"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("rangeseparator") !== -1 && _vm.form.isrange)?_c('el-form-item',{attrs:{"label":"分隔符"}},[_c('el-input',{model:{value:(_vm.form.rangeseparator),callback:function ($$v) {_vm.$set(_vm.form, "rangeseparator", $$v)},expression:"form.rangeseparator"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("text") !== -1)?_c('el-form-item',{attrs:{"label":"文字"}},[_c('el-input',{model:{value:(_vm.form.text),callback:function ($$v) {_vm.$set(_vm.form, "text", $$v)},expression:"form.text"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("contentposition") !== -1 )?_c('el-form-item',{attrs:{"label":"文字位置"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"请选择"},model:{value:(_vm.form.contentposition),callback:function ($$v) {_vm.$set(_vm.form, "contentposition", $$v)},expression:"form.contentposition"}},[_c('el-option',{attrs:{"label":"左","value":"left"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"中","value":"center"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"右","value":"right"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("fontsize") !== -1)?_c('el-form-item',{attrs:{"label":"文字大小"}},[_c('el-input-number',{attrs:{"min":12,"max":100,"step":1},model:{value:(_vm.form.fontsize),callback:function ($$v) {_vm.$set(_vm.form, "fontsize", $$v)},expression:"form.fontsize"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("textcolor") !== -1)?_c('el-form-item',{attrs:{"label":"文字颜色"}},[_c('el-color-picker',{attrs:{"show-alpha":""},model:{value:(_vm.form.textcolor),callback:function ($$v) {_vm.$set(_vm.form, "textcolor", $$v)},expression:"form.textcolor"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("datetype") !== -1 )?_c('el-form-item',{attrs:{"label":"选择单位"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"请选择"},model:{value:(_vm.form.datetype),callback:function ($$v) {_vm.$set(_vm.form, "datetype", $$v)},expression:"form.datetype"}},[_c('el-option',{attrs:{"label":"年月日-单个","value":"date"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"年周-单个","value":"week"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"年月-单个","value":"month"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"年-单个","value":"year"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"多日期","value":"dates"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"年月日时分秒-单个","value":"datetime"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"年月日时分秒-范围","value":"datetimerange"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"年月日-范围","value":"daterange"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"年月-范围","value":"monthrange"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.form.datetype=="datetimerange"||_vm.form.datetype=="daterange"||_vm.form.datetype=="monthrange" )?_c('div',[(_vm.form.showFrom.indexOf("startplaceholder") !== -1 )?_c('el-form-item',{attrs:{"label":"开始位置占位符"}},[_c('el-input',{model:{value:(_vm.form.startplaceholder),callback:function ($$v) {_vm.$set(_vm.form, "startplaceholder", $$v)},expression:"form.startplaceholder"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("endplaceholder") !== -1 )?_c('el-form-item',{attrs:{"label":"结束位置占位符"}},[_c('el-input',{model:{value:(_vm.form.endplaceholder),callback:function ($$v) {_vm.$set(_vm.form, "endplaceholder", $$v)},expression:"form.endplaceholder"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("rangeseparator") !== -1 )?_c('el-form-item',{attrs:{"label":"分隔符"}},[_c('el-input',{model:{value:(_vm.form.rangeseparator),callback:function ($$v) {_vm.$set(_vm.form, "rangeseparator", $$v)},expression:"form.rangeseparator"}})],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("radiotype") !== -1 )?_c('el-form-item',{attrs:{"label":"展示类型"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"请选择"},model:{value:(_vm.form.radiotype),callback:function ($$v) {_vm.$set(_vm.form, "radiotype", $$v)},expression:"form.radiotype"}},[_c('el-option',{attrs:{"label":"圆圈","value":"yuan"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"按钮","value":"button"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("checkboxtype") !== -1 )?_c('el-form-item',{attrs:{"label":"展示类型"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"请选择"},model:{value:(_vm.form.checkboxtype),callback:function ($$v) {_vm.$set(_vm.form, "checkboxtype", $$v)},expression:"form.checkboxtype"}},[_c('el-option',{attrs:{"label":"方块","value":"fang"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"按钮","value":"button"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("datatype") !== -1 )?_c('el-form-item',{attrs:{"label":"数据类型"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"请选择"},model:{value:(_vm.form.datatype),callback:function ($$v) {_vm.$set(_vm.form, "datatype", $$v)},expression:"form.datatype"}},[_c('el-option',{attrs:{"label":"配置数据","value":"option"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"接口数据","value":"url"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("url") !== -1 && _vm.form.datatype === "url" )?_c('el-form-item',{attrs:{"label":"接口地址"}},[_c('el-input',{model:{value:(_vm.form.url),callback:function ($$v) {_vm.$set(_vm.form, "url", $$v)},expression:"form.url"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("option") !== -1 && _vm.form.datatype == "option" )?_c('el-table',{staticClass:"tb-edit",staticStyle:{"width":"100%"},attrs:{"border":"","data":_vm.form.option,"highlight-current-row":"","size":"mini"}},[_c('el-table-column',{attrs:{"label":"显示值"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{attrs:{"size":"mini","placeholder":"请输入内容"},model:{value:(scope.row.label),callback:function ($$v) {_vm.$set(scope.row, "label", $$v)},expression:"scope.row.label"}})]}}],null,false,1453295051)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"传递值"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{attrs:{"size":"mini","placeholder":"请输入内容"},model:{value:(scope.row.value),callback:function ($$v) {_vm.$set(scope.row, "value", $$v)},expression:"scope.row.value"}})]}}],null,false,1391642086)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"操作"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"mini","type":"danger"},on:{"click":function($event){return _vm.handleDelete(scope.$index, scope.row)}}},[_vm._v("删除")])]}}],null,false,3778300450)})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("option") !== -1 && _vm.form.datatype == "option" )?_c('el-button',{staticStyle:{"margin-top":"10px"},attrs:{"size":"mini"},on:{"click":_vm.addoption}},[_vm._v("增加选项")]):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("border") !== -1)?_c('el-form-item',{attrs:{"label":"是否边框"}},[_c('el-switch',{attrs:{"active-color":"#13ce66","inactive-color":"#ff4949"},model:{value:(_vm.form.border),callback:function ($$v) {_vm.$set(_vm.form, "border", $$v)},expression:"form.border"}})],1):_vm._e(),_vm._v(" "),(_vm.form.showFrom.indexOf("stripe") !== -1)?_c('el-form-item',{attrs:{"label":"斑马纹"}},[_c('el-switch',{attrs:{"active-color":"#13ce66","inactive-color":"#ff4949"},model:{value:(_vm.form.stripe),callback:function ($$v) {_vm.$set(_vm.form, "stripe", $$v)},expression:"form.stripe"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"校验设置","name":"2"}},[(_vm.form.rules.length > 0)?_c('el-form',{attrs:{"model":_vm.form,"label-width":"80px","size":"small"}},[_c('el-form-item',{attrs:{"label":"是否必填"}},[_c('el-switch',{attrs:{"active-color":"#13ce66","inactive-color":"#ff4949"},model:{value:(_vm.form.rules[0].required),callback:function ($$v) {_vm.$set(_vm.form.rules[0], "required", $$v)},expression:"form.rules[0].required"}})],1),_vm._v(" "),(_vm.form.rules[0].required)?_c('el-form-item',{attrs:{"label":"提示信息"}},[_c('el-input',{model:{value:(_vm.form.rules[0].message),callback:function ($$v) {_vm.$set(_vm.form.rules[0], "message", $$v)},expression:"form.rules[0].message"}})],1):_vm._e()],1):_vm._e()],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"表单设置","name":"3"}},[_c('el-form',{attrs:{"model":_vm.formsetting,"label-width":"80px","size":"small"}},[_c('el-form-item',{attrs:{"label":"对齐方式"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"请选择"},model:{value:(_vm.formsetting.labelPosition),callback:function ($$v) {_vm.$set(_vm.formsetting, "labelPosition", $$v)},expression:"formsetting.labelPosition"}},[_c('el-option',{attrs:{"label":"左对齐","value":"left"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"右对齐","value":"right"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"顶对齐","value":"top"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"字段宽度"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"min":80,"max":200,"step":1,"stepstrictly":""},model:{value:(_vm.formsetting.labelwidth),callback:function ($$v) {_vm.$set(_vm.formsetting, "labelwidth", $$v)},expression:"formsetting.labelwidth"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"组件尺寸"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"请选择"},model:{value:(_vm.formsetting.formsize),callback:function ($$v) {_vm.$set(_vm.formsetting, "formsize", $$v)},expression:"formsetting.formsize"}},[_c('el-option',{attrs:{"label":"大","value":"medium"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"中","value":"small"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"小","value":"mini"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"lajitongdiv",style:({'z-index':_vm.zzcindex+1}),on:{"dragover":[_vm.dragover,function($event){$event.preventDefault();}],"dragleave":_vm.dragleave,"drop":_vm.drop}},[(!_vm.lj)?_c('svg',{attrs:{"t":"1584024586503","viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","p-id":"2016","width":"200","height":"200"}},[_c('path',{attrs:{"d":"M652.8 834.56c15.36 0 25.6-10.24 25.6-25.6v-307.2c0-15.36-10.24-25.6-25.6-25.6s-25.6 10.24-25.6 25.6v307.2c0 12.8 10.24 25.6 25.6 25.6z m-128 0c15.36 0 25.6-10.24 25.6-25.6v-307.2c0-15.36-10.24-25.6-25.6-25.6s-25.6 10.24-25.6 25.6v307.2c0 12.8 10.24 25.6 25.6 25.6z m281.6-614.4h-153.6v-51.2c0-28.16-23.04-51.2-51.2-51.2h-153.6c-28.16 0-51.2 23.04-51.2 51.2v51.2h-153.6c-28.16 0-51.2 23.04-51.2 51.2v51.2c0 28.16 23.04 51.2 51.2 51.2v460.8c0 56.32 46.08 102.4 102.4 102.4h358.4c56.32 0 102.4-46.08 102.4-102.4v-460.8c28.16 0 51.2-23.04 51.2-51.2v-51.2c0-28.16-23.04-51.2-51.2-51.2z m-358.4-25.6c0-15.36 10.24-25.6 25.6-25.6h102.4c15.36 0 25.6 10.24 25.6 25.6v25.6h-153.6v-25.6z m307.2 640c0 28.16-23.04 51.2-51.2 51.2h-358.4c-28.16 0-51.2-23.04-51.2-51.2v-460.8h460.8v460.8z m25.6-512h-512c-15.36 0-25.6-10.24-25.6-25.6s10.24-25.6 25.6-25.6h512c15.36 0 25.6 10.24 25.6 25.6 0 12.8-10.24 25.6-25.6 25.6z m-384 512c15.36 0 25.6-10.24 25.6-25.6v-307.2c0-15.36-10.24-25.6-25.6-25.6s-25.6 10.24-25.6 25.6v307.2c0 12.8 10.24 25.6 25.6 25.6z","p-id":"2017","fill":"#1296db"}})]):_vm._e(),_vm._v(" "),(_vm.lj)?_c('svg',{attrs:{"t":"1584029734035","viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","p-id":"6049","width":"200","height":"200"}},[_c('path',{attrs:{"d":"M652.8 834.56c15.36 0 25.6-10.24 25.6-25.6v-307.2c0-15.36-10.24-25.6-25.6-25.6s-25.6 10.24-25.6 25.6v307.2c0 12.8 10.24 25.6 25.6 25.6z m-128 0c15.36 0 25.6-10.24 25.6-25.6v-307.2c0-15.36-10.24-25.6-25.6-25.6s-25.6 10.24-25.6 25.6v307.2c0 12.8 10.24 25.6 25.6 25.6z m281.6-614.4h-153.6v-51.2c0-28.16-23.04-51.2-51.2-51.2h-153.6c-28.16 0-51.2 23.04-51.2 51.2v51.2h-153.6c-28.16 0-51.2 23.04-51.2 51.2v51.2c0 28.16 23.04 51.2 51.2 51.2v460.8c0 56.32 46.08 102.4 102.4 102.4h358.4c56.32 0 102.4-46.08 102.4-102.4v-460.8c28.16 0 51.2-23.04 51.2-51.2v-51.2c0-28.16-23.04-51.2-51.2-51.2z m-358.4-25.6c0-15.36 10.24-25.6 25.6-25.6h102.4c15.36 0 25.6 10.24 25.6 25.6v25.6h-153.6v-25.6z m307.2 640c0 28.16-23.04 51.2-51.2 51.2h-358.4c-28.16 0-51.2-23.04-51.2-51.2v-460.8h460.8v460.8z m25.6-512h-512c-15.36 0-25.6-10.24-25.6-25.6s10.24-25.6 25.6-25.6h512c15.36 0 25.6 10.24 25.6 25.6 0 12.8-10.24 25.6-25.6 25.6z m-384 512c15.36 0 25.6-10.24 25.6-25.6v-307.2c0-15.36-10.24-25.6-25.6-25.6s-25.6 10.24-25.6 25.6v307.2c0 12.8 10.24 25.6 25.6 25.6z","p-id":"6050","fill":"#d4237a"}})]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(54);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("0779413f", content, true, {});

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_showTableForm_vue__ = __webpack_require__(15);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30540333_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_showTableForm_vue__ = __webpack_require__(58);
function injectStyle (ssrContext) {
  __webpack_require__(56)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_showTableForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30540333_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_showTableForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(57);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(2)("1fc52d80", content, true, {});

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form',{ref:"dynamicValidateForm",staticClass:"demo-dynamic",attrs:{"model":_vm.dynamicValidateForm,"label-width":"0","size":"mini"}},[_c('el-table',{staticClass:"tb-edit",staticStyle:{"width":"100%"},attrs:{"stripe":_vm.data.stripe,"border":_vm.data.border,"data":_vm.dynamicValidateForm.domains,"highlight-current-row":""}},[_c('el-table-column',{attrs:{"type":"index","width":"50","align":"center"}}),_vm._v(" "),_vm._l((_vm.data.column),function(item,index){return _c('el-table-column',{key:'column'+ index,attrs:{"align":"center","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_c('el-form-item',{key:scope.$index,attrs:{"rules":item.rules,"prop":'domains.' + scope.$index + '.' + item.key}},[_c('FromItem',{attrs:{"item":item,"form":scope.row}})],1)],1)]}}],null,true)},[_c('template',{slot:"header"},[_c('div',[(item.rules.length > 0 && item.rules[0].required)?_c('span',{staticStyle:{"color":"#F56C6C"}},[_vm._v("*")]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.name))])])])],2)}),_vm._v(" "),_c('el-table-column',{attrs:{"align":"center","label":"操作","fixed":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"mini","type":"danger"},on:{"click":function($event){return _vm.removeDomain(scope.row)}}},[_vm._v("删除")])]}}])})],2),_vm._v(" "),_c('el-form-item',[_c('el-button',{staticStyle:{"margin-top":"10px"},on:{"click":function (){ return this$1.dynamicValidateForm.domains.push(JSON.parse(JSON.stringify(this$1.obj))); }}},[_vm._v("添加一行")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-form',{key:_vm.formkey,ref:"showform",attrs:{"model":_vm.form,"label-position":_vm.data.formsetting.labelPosition,"label-width":_vm.data.formsetting.labelwidth+'px',"size":_vm.data.formsetting.formsize}},[_c('el-row',{attrs:{"gutter":10}},[_vm._l((_vm.data.forms),function(item,index){return _c('el-col',{key:index,attrs:{"span":item.col}},[(["TableForm","Divider","p"].indexOf(item.type) == -1 )?_c('el-form-item',{attrs:{"label":item.name,"prop":item.key,"rules":item.rules}},[_c('Formitem',{attrs:{"item":item,"form":_vm.form}})],1):_vm._e(),_vm._v(" "),(item.type === 'Divider')?_c('el-divider',{attrs:{"content-position":item.contentposition}},[_vm._v(_vm._s(item.text))]):_vm._e(),_vm._v(" "),(item.type === 'p')?_c('p',{style:({'text-align': item.contentposition,'font-size':item.fontsize+'px',color:item.textcolor})},[_vm._v(_vm._s(item.text))]):_vm._e(),_vm._v(" "),(item.type==="TableForm")?_c('el-form-item',{attrs:{"label":item.name,"prop":item.key,"rules":item.rules}},[_c('showTableForm',{ref:item.id,refInFor:true,attrs:{"form":_vm.form,"data":item},on:{"settabledata":_vm.settabledata}})],1):_vm._e()],1)}),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.submitForm('showform')}}},[_vm._v("确定")])],1)],1)],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":6}},[_c('Assembly',{attrs:{"drag2":_vm.drag2},on:{"addcom":_vm.addcom,"setcom":_vm.setcom,"setdrag":_vm.setdrag,"deletecom":_vm.deletecom,"reset":_vm.reset}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('Forms',{ref:"forms",attrs:{"fromData":_vm.data,"formsetting":_vm.formsetting,"drag1":_vm.drag1,"drag2":_vm.drag2,"com":_vm.com},on:{"setdrag":_vm.setdrag,"reset":_vm.reset,"setdelcom":_vm.setdelcom,"addcom":_vm.addcom,"jiaohuan":_vm.jiaohuan,"setformcom":_vm.setformcom,"setdialogVisible":_vm.setdialogVisible,"save":_vm.save,"qingkong":_vm.qingkong,"downloadvue":_vm.downloadvue}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('AttrFrom',{attrs:{"fields":_vm.fields,"form":_vm.formcom,"formsetting":_vm.formsetting,"drag2":_vm.drag2},on:{"deletecom":_vm.deletecom}})],1)],1),_vm._v(" "),(_vm.dialogVisible)?_c('el-dialog',{attrs:{"title":"预览表单","visible":_vm.dialogVisible,"width":"70%","before-close":_vm.handleClose},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('ShowFrom',{attrs:{"data":{formsetting:_vm.formsetting,forms:_vm.data}}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// index.js